import { ButtonAPI, FieldAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnChange, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { AuthenticationService, HttpResponse, JWTToken } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import pollingService from '../../services/polling/polling-service';
import TokenConstants from '../../constants/TokenConstants';
import { ToastResponse } from '../../interfaces/ToastResponse';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { showToastNotificationMessage } from '../../utils/toast-notification-utils';
import { HttpServiceError, HttpServiceResponse, PatientHttpService } from '../../services/patient-http-service';
import ChangePasswordCommonsController from '../commons/change-password-commons-controller';
import { ChangePasswordAliases, FragmentNames } from '../../codegen';

@Controller({ component: ChangePasswordAliases.ROOT_MODAL, fragment: FragmentNames.CHANGE_PASSWORD })
class ChangePasswordController extends ChangePasswordCommonsController {

  @Inject(ChangePasswordAliases.OLD_PASSWORD_FIELD)
    fieldActualPassword!: FieldAPI;

  @Inject(ChangePasswordAliases.NEW_PASSWORD_FIELD)
    fieldNewPassword!: FieldAPI;

  @Inject(ChangePasswordAliases.CONFIRM_PASSWORD_FIELD)
    fieldNewConfirmPassword!: FieldAPI;

  @Inject(ChangePasswordAliases.RESET_FORM)
    formPassword!: FormAPI;

  @Inject(ChangePasswordAliases.PASSWORD_SUBMIT_BUTTON)
    confirmButton!: ButtonAPI;

  alteracaoCompleta = false;

  @OnMount({ target: ChangePasswordAliases.ROOT_MODAL })
  onMountModalAltSenha(): void {
    super.onMountModalAltSenha(this.fieldActualPassword, this.fieldNewPassword, this.fieldNewConfirmPassword, this.formPassword);
    this.confirmButton.setEnabled(false);
  }

  @OnChange({ target: ChangePasswordAliases.RESET_FORM })
  async onChangeFormAltSenha({ value }: ChangeEvent<Record<string, Value>>): Promise<void> {
    this.confirmButton.setEnabled(await super.isDataValid(this.fieldActualPassword, this.fieldNewPassword, this.fieldNewConfirmPassword, value));
  }

  @OnClick({ target: ['password-submit-button'] })
  onClickAltSenha(): void {
    this.confirmButton.setEnabled(false);
    this.formPassword.setEditing(false);
    if(this.isLogin()){
      this.alterPassword()
    } else{
      this.renewPassword();
    }
  }

  alterPassword(): void {
    const body = this.formPassword.getRecord();
    PatientHttpService.post(APPLICATION_ENDPOINTS.POST_ALTER_PASSWORD, {}, { body })
      .then(resp => {
        this.handleSuccess(resp);
      }).catch(({ response }: HttpServiceError<ToastResponse>) => {
        this.handleFailure(response);
      });
  }

  renewPassword(): void {
    const body = this.formPassword.getRecord();
    body.login = this.context.get('username');
    PatientHttpService.post(APPLICATION_ENDPOINTS.POST_RENEW_PASSWORD, {}, { body }).then(resp => {
      this.handleSuccess(resp);
    }).catch(({ response }: HttpServiceError<ToastResponse>) => {
      this.handleFailure(response);
    });
  }

  handleSuccess(resp: HttpResponse<unknown>): void {
    this.handleResponse(resp);
  }

  handleResponse(resp: HttpResponse<unknown>): void {
    this.alteracaoCompleta = true;
    showToastNotificationMessage(resp.body as ToastResponse);
    this.closeModalTimer();
  }
  closeModalTimer(): void {
    pollingService.createPolling('close-modal-renew-password', this.closeChangePasswordModal, 5000);
  }

  closeChangePasswordModal = ():void => {
    if (this.isLogin()) {
      const token = AuthenticationService.getJWTToken() as JWTToken;
      const patientId: string = token.claims[TokenConstants.PATIENT_ID] as string;
      const params = { patientId };
      this.historyService.push(APPLICATION_ROUTES.PROFILE, params);
    } else {
      this.historyService.push(APPLICATION_ROUTES.LOGIN);
    }
    pollingService.removePolling('close-modal-renew-password');
  }

  isLogin(): boolean {
    return !this.historyService.getCurrentRoute().includes(APPLICATION_ROUTES.LOGIN) && this.changePassword();
  }

  changePassword(): boolean {
    const token = AuthenticationService.getJWTToken();
    if (token == null) {
      return false;
    }
    return token.claims[TokenConstants.PATIENT_ID] as boolean;
  }

  async handleFailure(resp?: HttpServiceResponse<ToastResponse>): Promise<void> {
    this.formPassword.setEditing(true);
    this.confirmButton.setEnabled(await super.isDataValid(this.fieldActualPassword, this.fieldNewPassword, this.fieldNewConfirmPassword, this.formPassword.getRecord()));

    if (resp) {
      showToastNotificationMessage(resp.body);
    }
  }

  @OnClose({ target: ChangePasswordAliases.ROOT_MODAL })
  onRootModalClose(): void {
    if(this.isLogin()){
      const token = AuthenticationService.getJWTToken() as JWTToken;
      const patientId: string = token.claims[TokenConstants.PATIENT_ID] as string;
      const params = { patientId };
      this.historyService.push(APPLICATION_ROUTES.PROFILE, params);
    }
    else {
      this.historyService.push(APPLICATION_ROUTES.LOGIN);
    }
  }
}

export default ChangePasswordController;
